"use strict";

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenVerifier = void 0;

var base64url = require("./base64Url");

var cryptoClients_1 = require("./cryptoClients");

var errors_1 = require("./errors");

var sha256_1 = require("./cryptoClients/sha256");

var TokenVerifier =
/*#__PURE__*/
function () {
  function TokenVerifier(signingAlgorithm, rawPublicKey) {
    _classCallCheck(this, TokenVerifier);

    if (!(signingAlgorithm && rawPublicKey)) {
      throw new errors_1.MissingParametersError('a signing algorithm and public key are required');
    }

    if (typeof signingAlgorithm !== 'string') {
      throw 'signing algorithm parameter must be a string';
    }

    signingAlgorithm = signingAlgorithm.toUpperCase();

    if (!cryptoClients_1.cryptoClients.hasOwnProperty(signingAlgorithm)) {
      throw 'invalid signing algorithm';
    }

    this.tokenType = 'JWT';
    this.cryptoClient = cryptoClients_1.cryptoClients[signingAlgorithm];
    this.rawPublicKey = rawPublicKey;
  }

  _createClass(TokenVerifier, [{
    key: "verify",
    value: function verify(token) {
      if (typeof token === 'string') {
        return this.verifyCompact(token, false);
      } else if (typeof token === 'object') {
        return this.verifyExpanded(token, false);
      } else {
        return false;
      }
    }
  }, {
    key: "verifyAsync",
    value: function verifyAsync(token) {
      if (typeof token === 'string') {
        return this.verifyCompact(token, true);
      } else if (typeof token === 'object') {
        return this.verifyExpanded(token, true);
      } else {
        return Promise.resolve(false);
      }
    }
  }, {
    key: "verifyCompact",
    value: function verifyCompact(token, async) {
      var _this = this;

      // decompose the token into parts
      var tokenParts = token.split('.'); // calculate the signing input hash

      var signingInput = tokenParts[0] + '.' + tokenParts[1];

      var performVerify = function performVerify(signingInputHash) {
        // extract the signature as a DER array
        var derSignatureBytes = _this.cryptoClient.loadSignature(tokenParts[2]); // verify the signed hash


        return _this.cryptoClient.verifyHash(signingInputHash, derSignatureBytes, _this.rawPublicKey);
      };

      if (async) {
        return (0, sha256_1.hashSha256Async)(signingInput).then(function (signingInputHash) {
          return performVerify(signingInputHash);
        });
      } else {
        var signingInputHash = (0, sha256_1.hashSha256)(signingInput);
        return performVerify(signingInputHash);
      }
    }
  }, {
    key: "verifyExpanded",
    value: function verifyExpanded(token, async) {
      var _this2 = this;

      var signingInput = [token['header'].join('.'), base64url.encode(token['payload'])].join('.');
      var verified = true;

      var performVerify = function performVerify(signingInputHash) {
        token['signature'].map(function (signature) {
          var derSignatureBytes = _this2.cryptoClient.loadSignature(signature);

          var signatureVerified = _this2.cryptoClient.verifyHash(signingInputHash, derSignatureBytes, _this2.rawPublicKey);

          if (!signatureVerified) {
            verified = false;
          }
        });
        return verified;
      };

      if (async) {
        return (0, sha256_1.hashSha256Async)(signingInput).then(function (signingInputHash) {
          return performVerify(signingInputHash);
        });
      } else {
        var signingInputHash = (0, sha256_1.hashSha256)(signingInput);
        return performVerify(signingInputHash);
      }
    }
  }]);

  return TokenVerifier;
}();

exports.TokenVerifier = TokenVerifier;